import React from "react";
import { useSelector } from "react-redux";
import { Form, Input, Button, Row, Col, message } from "antd";
import {    fetchDataForDropdown } from "../../services/Service";
import Dropdown from "../search/Dropdown";
import filterPageLabels from "../search/searchPageLabels.json";
import { AddJob } from "../../services/Service";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

import "./JobCreationForm.css";

const { placeholders } = filterPageLabels;
const JobCreationForm = () => {
  const [form] = Form.useForm();
  const jobState = useSelector((state) => state.job);

  // Add null check
  if (!jobState) {
    return <p className="error-text">Error: Job state is missing!</p>;
  }

  const { loading, error } = jobState;

  const handleSubmit = async (values) => {
    try {
      
      const response = await AddJob(values);
      if (response) {
        toast.success("Job created successfully!");
        form.resetFields(); 
      } else {
        toast.error("Job creation failed. Please try again.");
      }
    } catch (err) {
      console.error("AddJob error:", err);
      toast.error("Job creation failed. Something went wrong.");
    }
  };
  
  

  return (
    <div className="job-creation-container">
      <h2 className="form-title">Job Creation</h2>
      <Form form={form} layout="vertical" onFinish={handleSubmit} className="job-form">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Job Title" name="jobTitle" rules={[{ required: true }]}> 
              <Input placeholder="Enter Job Title" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Job Description" name="jobDescription" rules={[{ required: true }]}>
              <Input.TextArea placeholder={placeholders.jobDescription} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Job Location" name="jobLocation" rules={[{ required: true }]}>
            <Dropdown
                fetchData={() => fetchDataForDropdown("locations")}
                placeholder={placeholders.location}
                includeAll={true}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Primary Skills" name="primarySkill" rules={[{ required: true }]}>
              <Dropdown
                fetchData={() => fetchDataForDropdown("primarySkills")}
                placeholder={placeholders.primarySkill}
                includeAll={true}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Secondary Skills" name="secondarySkill" rules={[{ required: true }]}>
            <Dropdown
             fetchData={() => fetchDataForDropdown("primarySkills")}
               placeholder={placeholders.secondarySkill}
                 mode="multiple"/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Experience Required" name="experienceRequired" rules={[{ required: true }]}>
              <Input placeholder={placeholders.requiredYears} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="Job Link" name="jobLink" >
              <Input placeholder={placeholders.jobLink} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="JobID" name="jobId" >
              <Input placeholder={placeholders.jobId} />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="POC Id" name="pocId" rules={[{ required: true }]}>
              <Input placeholder={placeholders.PocId} />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="center" gutter={16}>
          <Col>
            <Button htmlType="reset">Reset</Button>
          </Col>
          <Col>
            <Button type="primary" htmlType="submit" loading={loading}>
              {loading ? "Submitting..." : "Submit"}
            </Button>
          </Col>
        </Row>

        {error && <p className="error-text">{error}</p>}
      </Form>
    </div>
  );
};

export default JobCreationForm;
